import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Tooltip } from '@spa/shared/index';
import Exclamation from '@spa/shared/svg/exclamation';
import { Container, Label, RegistrationValue, TooltipContent } from './styles';
import { theme } from '@spa/shared/theme';

const RegistrationNumber = ({ registrationNumber }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Label>{t('Registration Number')}</Label>
      <RegistrationValue>{registrationNumber}</RegistrationValue>
      <Tooltip>
        <Exclamation color={theme.registrationNumber.iconColor} />
        <TooltipContent>
          {t(
            'This is the official registration number assigned by Spanish authorities to verify this rental is legally listed'
          )}
        </TooltipContent>
      </Tooltip>
    </Container>
  );
};

RegistrationNumber.propTypes = {
  registrationNumber: PropTypes.string.isRequired
};

export default RegistrationNumber;
